export const PRICE_HISTORY_ROW_TYPE = {
	PREVIOUS_SEASON_AVG: "previous_season_avg",
	MANUAL: "manual",
};
